const createKivraImage = (url): Promise<HTMLImageElement> => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener('load', () => resolve(image));
    image.addEventListener('error', (error) => reject(error));
    image.setAttribute('crossOrigin', 'anonymous'); // needed to avoid cross-origin issues on CodeSandbox
    image.src = url;
  });
};

// Copy from "https://codesandbox.io/s/react-easy-crop-demo-with-cropped-output-q8q1mnr01w?from-embed=&file=/src/cropImage.js:0-2289"
async function getKivraCroppedImg(imageSrc: string, pixelCrop: { x: number; y: number; width: number; height: number }) {
  const image = await createKivraImage(imageSrc);

  // --- Steg 1: beskär vald yta ---
  const workCanvas = document.createElement('canvas');
  const workCtx = workCanvas.getContext('2d');
  if (!workCtx) throw new Error('Canvas 2D context saknas');

  workCanvas.width = pixelCrop.width;
  workCanvas.height = pixelCrop.height;

  workCtx.drawImage(image, pixelCrop.x, pixelCrop.y, pixelCrop.width, pixelCrop.height, 0, 0, pixelCrop.width, pixelCrop.height);

  // --- Steg 2: skala till exakt 512x512 ---
  const finalCanvas = document.createElement('canvas');
  finalCanvas.width = 512;
  finalCanvas.height = 512;
  const finalCtx = finalCanvas.getContext('2d');
  if (!finalCtx) throw new Error('Canvas 2D context saknas');

  finalCtx.imageSmoothingEnabled = true;
  finalCtx.imageSmoothingQuality = 'high';
  finalCtx.drawImage(workCanvas, 0, 0, 512, 512);

  // Returnera som PNG (ändra till 'image/jpeg' om du vill)
  return finalCanvas.toDataURL('image/png');
}

export const cropKivraImage = async (image: string, croppedAreaPixels, onError: (err) => void) => {
  try {
    return await getKivraCroppedImg(image, croppedAreaPixels);
  } catch (err) {
    onError(err);
    return null;
  }
};
